<template>
  <div class="row">
    <div class="col-12  col-xl-5">
      <div class="row light-bg extra-rounded my-2 mx-0">
        <div class="col-6 px-0">
          <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Price</span>
        </div>
        <div class="col-6 px-0 ">
            <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
              <transition name="text" mode="out-in">
               <div class="d-inline">
                 <slot name="price"/>
               </div>
              </transition>
              <br/>
            </span>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-7">
      <slot name="buttons"/>
    </div>
    <div class="col-12">
      <slot name="error"/>
    </div>

  </div >
</template>
<script>
export default {
  name: "LotControlPanelCompactTemplate"
}
</script>
<style scoped>

</style>
